import { apiClient } from './client';

export interface AuditLog {
  id: number;
  event: string;
  event_label: string;
  auditable_type: string | null;
  auditable_id: number | null;
  old_values: Record<string, unknown> | null;
  new_values: Record<string, unknown> | null;
  ip_address: string | null;
  user_agent: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
}

export interface AuditLogMeta {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface AuditFilters {
  event?: string;
  auditable_type?: string;
  date_from?: string;
  date_to?: string;
  per_page?: number;
  page?: number;
}

export interface AuditListResponse {
  success: boolean;
  data: AuditLog[];
  meta: AuditLogMeta;
}

export const auditApi = {
  list: (filters: AuditFilters = {}) =>
    apiClient
      .get<AuditListResponse>('/audits', { params: filters })
      .then((r) => r.data),

  find: (id: number) =>
    apiClient
      .get<{ success: boolean; data: AuditLog }>(`/audits/${id}`)
      .then((r) => r.data.data),
};
